module.exports = __webpack_public_path__ + "static/media/header_popup_dropdown_icon.ab3ee42d.svg";